import { render } from "./S114947.vue?vue&type=template&id=3660616b"
const script = {}
script.render = render

export default script